import { useQuery } from "@tanstack/react-query";

import { apiFetch } from "../api/client";

export interface LocationLimit {
  count: number;
  /** null は無制限（Business）。 */
  limit: number | null;
  over_limit: boolean;
}

/**
 * プランの拠点数上限（Free 1 / Starter 2 / Pro 5 / Business 無制限）。
 *
 * 🔴 **機能フラグ（旧 `multi_location`）ではなく数で判定する**＝2026-08-01 に
 * 「拠点別＝Business」の機能ゲートを階段へ変更した。静的な最小プランでは
 * 「3拠点なら Pro・6拠点なら Business」を表現できない。
 *
 * 執行は backend（403）。ここは表示用で、失敗しても画面を落とさない。
 */
export function useLocationLimit(): LocationLimit | undefined {
  const { data } = useQuery({
    queryKey: ["location-limit"],
    queryFn: () => apiFetch<LocationLimit>("/api/locations/limit"),
    retry: false,
  });
  return data;
}
